import React from 'react';
import { Globe } from 'lucide-react';
import { useApp } from './AppContext';

const LanguageSelector = () => {
  const { currentLanguage, changeLanguage, languages } = useApp();

  return (
    <div className="flex items-center space-x-2">
      <Globe className="w-4 h-4" />
      <select 
        value={currentLanguage}
        onChange={(e) => changeLanguage(e.target.value)}
        className="bg-gray-900 dark:bg-gray-950 text-white text-sm border-none focus:ring-0"
      >
        {Object.entries(languages).map(([code, name]) => (
          <option key={code} value={code}>{name}</option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;